import { ListItem, styled } from "@mui/material";

// Styled ListItem for soft-deleted chats in filtered lists.
// 0.38 opacity matches the MD3 disabled-content standard.
export const DeletedChatListItem = styled(ListItem)({
  opacity: 0.38,
});
